import React, { useEffect, useState } from "react";

type MessageSendingTextProps = {
  // TODO: add props here
};

const textArray = [
  "Sending your message...",
  "Processing your request...",
  "Almost there...",
  "Hang tight, we're on it...",
  "Just a moment, please...",
  "Your message is being sent...",
];

const MessageSendingText: React.FC<MessageSendingTextProps> = (props) => {
  // Rotating the displayed message provides feedback that the process is ongoing and avoids static UI
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev < textArray.length - 1 ? prev + 1 : 0));
    }, 7000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-primary/50 mt-auto w-full rounded-md p-2 px-3">
      <div className="font-bold">{textArray[index]}</div>
      <div className="text-sm">
        Please note: Keep this chat open - fetching is only available for 24
        hours.
      </div>
    </div>
  );
};

export default MessageSendingText;
